import { render } from "./Vouchers.vue?vue&type=template&id=001058b2&scoped=true"
import script from "./Vouchers.vue?vue&type=script&lang=js"
export * from "./Vouchers.vue?vue&type=script&lang=js"

import "./Vouchers.vue?vue&type=style&index=0&id=001058b2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001058b2"]])

export default __exports__